module.exports = __webpack_public_path__ + "static/complaint-form-e1e1975a83baadb2ce5481c8656749c6.jpg";